import en from '@/_plugins/time/translates/en.json'
import ru from '@/_plugins/time/translates/ru.json'
import type { FantasyDateParts } from './types'

const TIME_TRANSLATES = { ru, en } as const
const FANTASY_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/
/**
 * Парсит дату из строки вида "2026-02-17"
 */
export const parseFantasyDate = (date: string): FantasyDateParts | null => {
  const match = FANTASY_DATE_PATTERN.exec(date)

  if (!match) {
    return null
  }

  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])

  return { year, month, day }
}

/**
 * Возвращает короткую запись месяца (Январь - Янв, December - Dec)
 */
export const getFormattedMonth = ({
  locale,
  month
}: {
  month?: number
  locale: string
}) => {
  if (!month || month < 1) {
    return null
  }

  const translates =
    TIME_TRANSLATES[locale as keyof typeof TIME_TRANSLATES] ??
    TIME_TRANSLATES.ru

  return translates.months[month - 1]?.slice(0, 3) ?? ''
}
